import axios from 'axios'
import store from '../store'
import { URL } from '../const'

import {
  TOGGLE_VISIBILITY
} from './types'

export const toggleVisibility = (property_id, panel_id, show) => async dispatch => {
  const config = {
    headers: {
      'Authorization': `Token ${store.getState().user.token}`
    }
  }
  const url = `${URL}panel_show`
  const data = {
    property_id,
    panel_id,
    show
  }

  try {
    console.log('url: ', url)
    console.log('data: ', data)
    const res = await axios.post(
      url,
      data,
      config
    )
    console.log('res: ', res)
    dispatch({
      type: TOGGLE_VISIBILITY
      // payload: res.data.show
    })
  } catch (error) {
    console.log('error: ', error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/showActions.js